module.exports = __webpack_public_path__ + "img/chevron-izquierdo-1.b906f1d6.svg";